import React, {useEffect, useMemo} from 'react';
import {useEffect, useRef, useState} from 'react'
import {
  SDrawerOrModal, SListTabs,
} from 'shj-components';
import {message, Tabs} from 'antd';
import styles from './index.module.less';
import {channelClueUpdate} from "@/services/member.ts";
import {ChooseList} from "./chooseList.tsx";
import {useSetState} from "ahooks";
import {isArray} from "lodash-es";

export default function AllowChannelWorkerModal(props) {
  const {
    editId,
    clueId,
    open = false,
    onClose = () => {
    },
    reload = () => {
    },
  } = props

  const submitObj = useRef({})
  const listRef = useRef()
  const [state, setState] = useSetState({
    data : [
      { key: 'anchor', label: '主播' },
      { key: 'advert', label: '优化师' },
      { key: 'liveOperation', label: '直播运营员' },
    ],
    resourceObj: {},
    activeKey: '',
    loading: false,
  })

  useEffect(() => {
    submitObj.current = {}
  }, [open]);

  const onSubmit = async () => {
    setState({loading: true})
    try {
      const obj = {...submitObj.current}
      const query = {}
      console.log(obj)
      Object.keys(obj)?.forEach(key => {
        const item = obj[key]
        if (isArray(item)){
          query[key+ 'Name'] = item[0]?.userName
          query[key+ 'EmployeeId'] = item[0]?.ucenterUserId
        }
      })
      const res = await channelClueUpdate({ ...query, id: editId, clueId})
        message.success(res.message || `操作成功`);
        onClose();
        reload();
    } catch (err) {
      console.log(err)
    } finally {
      setState({loading: false})
    }
  }

  const tabs = useMemo(() => {
    return open ? state.data.map(item => {
      const selectedRows = submitObj.current[item.key]
      return {
        ...item,
        children: <ChooseList key={item.key}
                        updateSelectedObj={(rows) => { submitObj.current[item.key] =  rows }}
                        rows={selectedRows}
                        ref={listRef}
                        editId={editId}/>
      }
    }) : []
  }, [state.data, submitObj.current, open])

  return (
      <div>
        <SDrawerOrModal
            mode="drawer"
            open={open}
            onCancel={() => onClose()}
            onOk={onSubmit}
            loading={state.loading}
            width={900}
            title={'绑定渠道人员'}
        >
          <div className={styles.tableBox}>
            <Tabs items={tabs}/>
          </div>
        </SDrawerOrModal>
      </div>
  )
}